<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
			<path
				class="regular"
				d="M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24v8V80 304v48V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352H424c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24H48V24zm0 56H376l-62.4 83.2c-12.8 17.1-12.8 40.5 0 57.6L376 304H48V80z"
			/>

			<path
				class="light"
				d="M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V32 64 320v32V496c0 8.8 7.2 16 16 16s16-7.2 16-16V352H424c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24H32V16zm0 48H408L326.4 172.8c-8.5 11.4-8.5 27 0 38.4L408 320H32V64z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'FlagSwallowtailIcon',
	components: { Icon },
	props,
}
</script>
